module.exports = __webpack_public_path__ + "static/media/restaurant-food3.165b890d.jpeg";